var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverdueInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.5L15 8.5M9.50003 9H9.51003M14.5 14H14.51M19 21.5V5.5C19 4.39543 18.1046 3.5 17 3.5H7C5.89543 3.5 5 4.39543 5 5.5V21.5L8.5 19.5L12 21.5L15.5 19.5L19 21.5ZM10 9C10 9.27614 9.77614 9.5 9.5 9.5C9.22386 9.5 9 9.27614 9 9C9 8.72386 9.22386 8.5 9.5 8.5C9.77614 8.5 10 8.72386 10 9ZM15 14C15 14.2761 14.7761 14.5 14.5 14.5C14.2239 14.5 14 14.2761 14 14C14 13.7239 14.2239 13.5 14.5 13.5C14.7761 13.5 15 13.7239 15 14Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdueInvoices);
export default __webpack_public_path__ + "static/media/OverdueInvoices.812e2ba71dd67a23c7b385f839987cfc.svg";
export { ForwardRef as ReactComponent };